import React from 'react';
import PropTypes from 'prop-types';

import {
  DATA_TABLE_SOURCE_LISTING_NOTES,
  DATA_TABLE_VIEW_ID_LISTING_NOTES_VISIBLE_TO_PARTNER,
} from 'common/dataTableConstants';

import SrPartnerSection from 'client/components/SrPartnerSection';
import SrDataTableConnected from 'client/components/SrDataTableConnected';
import SrNotesList, {
  SR_LISTING_NOTES_VISIBLE_TO_PARTNER,
  SR_NOTES_LIST_THEME_GREYCLIFF,
} from 'client/components/SrNotesList';
import SrCard from './SrCard/SrCard';

const SrPartnerSunroomNotes = ({ listingId, dispatch, currentUser }) => (
  <SrDataTableConnected
    itemsPropName="notes"
    rootViewId={DATA_TABLE_VIEW_ID_LISTING_NOTES_VISIBLE_TO_PARTNER}
    dataSource={DATA_TABLE_SOURCE_LISTING_NOTES}
    initialViewSettings={{
      sort: {
        createdDate: 'desc',
      },
      filter: {
        listingId,
        visibleToPartner: true,
      },
    }}
  >
    {({ notes, reloadItems, onInfiniteScrollWrapperRef }) => {
      if (notes.length === 0) {
        return null;
      }

      return (
        <SrPartnerSection title="Leasing Team Notes">
          <SrCard overflowY="auto" maxHeight="600px" ref={onInfiniteScrollWrapperRef}>
            <SrNotesList
              maxHeight="unset"
              type={SR_LISTING_NOTES_VISIBLE_TO_PARTNER}
              theme={SR_NOTES_LIST_THEME_GREYCLIFF}
              notes={notes}
              dispatch={dispatch}
              reloadDataTable={(noteId) => {
                reloadItems({
                  count: 1,
                  filter: {
                    'listingNotes.id': noteId,
                    'listingNotes.visibleToPartner': true,
                  },
                });
              }}
              currentUser={currentUser}
            />
          </SrCard>
        </SrPartnerSection>
      );
    }}
  </SrDataTableConnected>
);

SrPartnerSunroomNotes.propTypes = {
  listingId: PropTypes.number.isRequired,
  dispatch: PropTypes.func.isRequired,
  currentUser: PropTypes.object.isRequired,
};

SrPartnerSunroomNotes.displayName = 'SrPartnerSunroomNotes';

export default SrPartnerSunroomNotes;
